import React from 'react';
import { Helmet } from "react-helmet";
import './SobreMi.css';

const SITE = "https://juanipavlovsky.com.ar";

const backgroundStyle = {
  backgroundImage: 'url("/images/sobremi-fondo.jpg")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  position: 'relative',
  width: '100%',
  height: '100%',
};

const SobreMi = () => {
  const canonical = `${SITE}/sobre-mi`;
  return (
    <>
      <Helmet>
        <title>Sobre mí | Juani Pavlovsky</title>
        <meta
          name="description"
          content="Conocé la trayectoria y el enfoque de Juani Pavlovsky."
        />
        <link rel="canonical" href={canonical} />

        {/* Open Graph */}
        <meta property="og:title" content="Sobre mí | Juani Pavlovsky" />
        <meta property="og:description" content="Conocé la trayectoria y el enfoque de Juani Pavlovsky." />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={`${SITE}/images/og-home.jpg`} />

        {/* Twitter */}
        <meta name="twitter:title" content="Sobre mí | Juani Pavlovsky" />
        <meta name="twitter:description" content="Conocé la trayectoria y el enfoque de Juani Pavlovsky." />
        <meta name="twitter:image" content={`${SITE}/images/og-home.jpg`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Inicio", "item": `${SITE}/` },
            { "@type": "ListItem", "position": 2, "name": "Sobre mí", "item": `${SITE}/sobre-mi` }
          ]
        })}</script>


      </Helmet>
      <div className="sobre-mi-container">
        {/* Imagen de cabecera con texto superpuesto */}
        <div className="header-image video-header">
          <video autoPlay loop muted playsInline>
            <source src="/images/video-portada.mp4" type="video/mp4" />
            Tu navegador no soporta el video.
          </video>
          <div className="header-text">
            <h1>Juani Pavlovsky</h1>
          </div>
        </div>

        {/* Texto en dos columnas */}
        <h2 className='subtitulo'>¿Qué es la fotografía para mi?</h2>
        <div className="bio-text">

          <div className="column">
            <p>
              Cuando me introduje en el mundo de la fotografía más allá del hobby y pasión por el cual empecé a sacar fotos, me gustaba ver el trabajo de otros fotógrafos para buscar inspirarme y aprender de sus técnicas y carreras.
            </p>
            <p>
              Me pasó que durante años veía el trabajo de otros fotógrafos y me intrigaba y, a la vez, asombraba cómo sus trabajos eran consistentes y marcaban un estilo, una dirección bien marcada de su temática desarrollada y su técnica depurada.
            </p>
            <p>
              Siempre me apasionó la naturaleza en todas sus formas y llevar esa pasión a la imagen no me resultó difícil. Pero cuando veía fotos en todas sus diversas temáticas sentía que me costaba encontrar la que a mí me representara. Yo le sacaba fotos a todo lo que veía y me rodeaba, quería acaparar todo. Sabía que técnicamente no era el mejor, pero sabía que podía capturar momentos únicos porque me gustaba observar y contemplar lo que sucedía a mi alrededor y me podía quedar solo durante horas, esperando el momento justo para sacar fotos a eso que estaba buscando o simplemente esperar que algo nuevo apareciera para retratar.
            </p>

          </div>
          <div className="column">
            <p>
              Quería ser todos los fotógrafos a la vez, pero también poder experimentar mi unicidad. Fue después de mucho tiempo que, escribiendo la introducción a mis libros de fotografía, caí en una frase que me iba a indicar mi propio camino. Simple ideas (se puede usar en español y en inglés). Esas fueron las dos palabras que me marcaron y que describen mi esencia hasta el día de hoy en cada foto que saco. Lo simple, lo que muchas veces pasa desapercibido para otros en la cotidianeidad, a mí me habla y me permite entrar en un diálogo profundo del cual puedo sacar un registro y dejarlo vivo para la posteridad.
            </p>
            <p>
              Si me preguntan qué es lo que quiero transmitir con mis fotos, digo eso: las cosas simples de la vida, aquellas que parecen no tener mucha importancia pero, sin embargo, para mí lo tienen, y es el querer compartir un momento de eso con los demás. Todo aquel que aprecie lo profundo, lo que tiene sentido oculto, podrá ver en mis obras eso y más, porque en definitiva cada imagen habla distinto para cada quien la ve y observa. Les deseo puedan disfrutar conmigo este camino personal de intimidad y reflexión en imágenes únicas que están ahí para transmitir sensaciones y momentos vividos.
            </p>

          </div>
        </div>
        <p className='gracias'>Gracias</p>
        <h3 className='dedicacion'>Juani Pavlovsky</h3>

        {/* Imagen final centrada */}
        <div className="imagen-descentrada-fotografo">
          <img src="/images/perfil.jpeg" alt="Juani en acción" />
        </div>

        {/* Background - estudios - premios */}
        <div style={backgroundStyle} className="sobre-mi-bg">
          <div style={{
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(2px)',
            paddingTop: '145px',
            paddingBottom: '3rem',
            paddingRight: '2rem',
            paddingLeft: '2rem',
            textAlign: 'left',
            position: 'relative',
            zIndex: 1,
          }}>
            <div className="info-box">
              <h2>Mi recorrido como fotógrafo</h2>
              <ul>
                <li><strong>Dictado de clases:</strong> Colegio María de Guadalupe y clases grupales e individuales para <br />adultos.</li>
                <li>
                  <strong>Estudios de fotografía:</strong> Colegio Cardenal Newman, formación con Nicolás Levin, Inés <br />Miguens y autodidacta con más de 15 años como fotógrafo amateur.
                </li>
                <li>
                  <strong>Trabajos realizados:</strong> Dogma (espacio activo de arte), Belvedere (casa de cuadros y <br />marcos), Paseo del Arte (diseño de cuadros), Flox (regalos para casamientos), Tealosophy <br />(casa de té by Inés Berton), Paula y Agustina Ricci, Menoca, Zeina, Fernandez Madero,<br /> Cool Site, Tube’s, varias ONG’s y Fundaciones (Cáritas, Cascos Verdes, Luz de Esperanza,<br /> Colegio María de Guadalupe).
                </li>
                <li>
                  <strong>Exhibiciones destacadas:</strong>
                  <ul>
                    <li>📍 <strong>53ª Bienal de Venecia, Pabellón de NY Arts Magazine</strong> (08-06-2009 al 01-11-2009)</li>
                    <li>📍 <strong>Ginebra, Saatchi & Saatchi (Suiza)</strong>: ART-gentina: Visions of Contemporary Art (16-09-2009 al 03-10-2009)</li>
                    <li>📍 <strong>Diario La Nación (LNR)</strong>: Foto publicada en la revista de los domingos (05-07-2009)</li>
                  </ul>
                </li>
                <li>
                  <strong>Publicaciones:</strong> Libro de fotografía “El Campo y su entorno” (2009) y “Postales de Ecuador” (2011).
                </li>
                <li>
                  <strong>Premios:</strong> Primer premio Banco Itaú a fotografía abstracta por “Escalera caracol” (2013).
                </li>
                <li>
                  <strong>Instalaciones:</strong> Fotografías en la sala de espera del Centro de Hematología Pavlovsky (2015).
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default SobreMi;
